import React from "react";
import PropTypes from "prop-types";

import MoreContent from "@/src/components/listing-detail/more-content";

import styles from "./style.module.css";

const CompanyDetailMoreContent = ({ introText }) => {
  return (
    <MoreContent defaultHeight={95}>
      <div className={styles.introText} dangerouslySetInnerHTML={{ __html: introText }} />
    </MoreContent>
  );
};

CompanyDetailMoreContent.propTypes = {
  introText: PropTypes.string,
};
export default CompanyDetailMoreContent;
